import React, {ReactNode, useMemo} from 'react';
import cx from 'classnames';
import styles from '../styles/Table.module.scss';

type RowProps = {
    top: number;
    height: number;
    rowIndex: number;
    children?: ReactNode;
    componentClasses?: string;
    isActive?: boolean;
};

export const Row = (props: RowProps) => {
    const {top, height, rowIndex, children, componentClasses, isActive} = props;
    const rowStyles = useMemo(() => ({height, top}), [height, top]);
    const isEven = rowIndex % 2 === 1;

    return (
        <div
            key={rowIndex}
            className={cx(styles.tableRow, componentClasses, {
                [styles.tableRowOdd]: !isEven,
                [styles.tableRowEven]: isEven,
                [styles.tableRowActive]: isActive
            })}
            style={rowStyles}
            data-index={rowIndex}
        >
            {children}
        </div>
    );
};
